
       
       
       <!------------------------------Employee  list Show ------------------------------>
       <app-employee-list *ngIf="!isEdit" (isViewEdit)="dataEmitfromChild($event)" [ViewEdit]="ViewEdit">    </app-employee-list>


       <!------------------------------Employee  Add and Edit  Show ------------------------------>
       <app-employee-create-edit *ngIf="isEdit" (isViewEdit)="dataEmitfromChild($event)" [ViewEdit]="ViewEdit">   </app-employee-create-edit>
     